export default __webpack_public_path__ + "b1c05b1c332bd2bf38e1790fd762b349.jpg";